import { Middleware } from 'redux'
import api from "../../services/api";

export const apiMiddleware : Middleware = storeApi => next => action => {
    let method = null;
    const { type, params } = action;
    if (type.startsWith('REQUEST_READ_')) {
        method = 'GET';
    }
    else if (type.startsWith('REQUEST_CREATE_')) {
        method = 'POST';
    }
    else if (type.startsWith('REQUEST_UPDATE_')) {
        method = 'PUT';
    }
    else if (type.startsWith('REQUEST_DELETE_')) {
        method = 'DELETE';
    }

    let body = params['body'];
    let headers = params['headers'];

    if (method)
    {
        api(method,type,body,headers)
            .then((response: any) => {
                storeApi.dispatch({
                    type: action.type.replace('REQUEST', 'SUCCESS'),
                    payload: response
                })
            })
            .catch((error: any) => {
                storeApi.dispatch({
                    type: action.type.replace('REQUEST', 'FAIL'),
                    error})
            })
    }

    next(action);
}